import { createSlice } from "@reduxjs/toolkit";
import { defaultNewCompletedRequestBody, DefaultNewCompletedRequestBodyType } from "../../../constant/document";
import { fetchNewCompletedAudios, fetchPaginateNewCompletedAudios, fetchRefreshNewCompleted, resetNewCompletedTable, setNewCompletedAutoRefresh, stopNewCompletedAutoRefresh, switchNewCompletedAutoFresh, updateNewCompletedRequestBody } from "./NewCompletedAction";

export interface PaginationType {
  page: number;
  pageSize: number;
  hasMore: boolean;
  loading: boolean;
}

interface AutoRefreshStateType {
  autoRefresh: boolean;
  currentIntervalId: NodeJS.Timer | undefined;
  error: string | undefined;
  loading: boolean;
}

interface NewCompletedAudiosStateType {
  data: any;
  loading: boolean;
  error: string | undefined;
  currentRequestBody: DefaultNewCompletedRequestBodyType;
  pagination: PaginationType;
  autoRefreshNewCompletedState: AutoRefreshStateType;
  success: boolean;
  message: string;
  currentTenantId: number;
}

const NewCompletedAudiosInitialState: NewCompletedAudiosStateType = {
  data: [],
  loading: false,
  error: undefined,
  currentRequestBody: defaultNewCompletedRequestBody,
  pagination: {
    page: 2,
    pageSize: 30,
    hasMore: true,
    loading: false,
  },
  autoRefreshNewCompletedState: {
    autoRefresh: true,
    currentIntervalId: undefined,
    error: "",
    loading: false,
  },
  success: false,
  message: "",
  currentTenantId: 0,
};

const NewCompletedAudiosSlice = createSlice({
  initialState: NewCompletedAudiosInitialState,
  name: "transcribe",
  reducers: {},
  extraReducers(builder) {
    builder
      //Fetch NewCompleted data from API
      .addCase(fetchNewCompletedAudios.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchNewCompletedAudios.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchNewCompletedAudios.rejected, (state, action) => {
        state.error = action.error.message;
        // state.error = action.error?.message ?? "";
        state.loading = false;
      })

      //Infinite Scrolling
      .addCase(fetchPaginateNewCompletedAudios.pending, (state, action) => {
        state.pagination.loading = true;
      })
      .addCase(fetchPaginateNewCompletedAudios.fulfilled, (state, action) => {
        state.pagination.page = state.pagination.page + 1;
        state.data = state.data.concat(action.payload.data);
        state.pagination.hasMore = action.payload.data.length === state.pagination.pageSize;
        state.pagination.loading = false;
      })
      .addCase(fetchPaginateNewCompletedAudios.rejected, (state, action) => {
        state.error = action.error.message;
        state.pagination.loading = false;
      })

      //Search InNewCompleted
      .addCase(updateNewCompletedRequestBody, (state, action) => {
        state.currentRequestBody = action.payload;
      })

      //Reset
      .addCase(resetNewCompletedTable, (state, action) => {
        return {
          ...NewCompletedAudiosInitialState,
          data: state.data,
          autoRefreshNewCompletedState: state.autoRefreshNewCompletedState,
        };
      })

      //  Refresh
      .addCase(fetchRefreshNewCompleted.pending, (state, action) => {
        state.autoRefreshNewCompletedState.loading = true;
      })
      .addCase(fetchRefreshNewCompleted.fulfilled, (state, action) => {
        state.data = action.payload;
        state.autoRefreshNewCompletedState.loading = false;
      })
      .addCase(fetchRefreshNewCompleted.rejected, (state, action) => {
        state.autoRefreshNewCompletedState.error = action.error.message;
        state.autoRefreshNewCompletedState.loading = false;
      })

      //Auto Refresh
      .addCase(setNewCompletedAutoRefresh, (state, action) => {
        state.autoRefreshNewCompletedState.currentIntervalId = action.payload.intervalId;
      })
      .addCase(switchNewCompletedAutoFresh, (state, action) => {
        state.autoRefreshNewCompletedState.autoRefresh = action.payload.autoRefresh;
      })
      .addCase(stopNewCompletedAutoRefresh, (state, action) => {
        clearInterval(state.autoRefreshNewCompletedState.currentIntervalId);
      });
  },
});

export default NewCompletedAudiosSlice.reducer;
